// Restricted organizations for MindCloud staff. Contract:
// docs/plans/active/api/2026-10-22-restricted-org-staff-access/adr/001-enforce-in-request-authorization.md

// The app a route belongs to (api middleware/auth/resolveRouteApp.js). A staff member in a restricted organization
// needs an approval for that app: `shared` routes accept either approval, and `user` routes read no organization
// data, so they are not checked.
export const ROUTE_APP = Object.freeze({ gravity: 'gravity', cirra: 'cirra', shared: 'shared', user: 'user' });

// The apps an approval is granted for.
export const STAFF_ACCESS_APPS = Object.freeze([ROUTE_APP.gravity, ROUTE_APP.cirra]);

export const STAFF_ACCESS_APP_LABELS = Object.freeze({ [ROUTE_APP.gravity]: 'Gravity', [ROUTE_APP.cirra]: 'Cirra' });

export const STAFF_ACCESS_MANAGE_PERMISSION = 'staff_access:manage';

// dbo.company.settings key, written only by the staff-access flag route.
export const STAFF_ACCESS_RESTRICTED_SETTING = 'staffAccessRestricted';

// Whether a company row (with its settings) is restricted for MindCloud staff.
export const isCompanyStaffAccessRestricted = (company) => company?.settings?.[STAFF_ACCESS_RESTRICTED_SETTING] === true;

export const ORG_ACCESS_RESTRICTED_CODE = 'ORG_ACCESS_RESTRICTED';

export const STAFF_ACCESS_REASON_MAX_LENGTH = 1000;

// A user pref (main.user_pref, top-level key): Super Admins who turn it on are emailed new requests. Off by default.
export const STAFF_ACCESS_REQUEST_EMAILS_PREF = 'staffAccessRequestEmails';
